import { useState, useEffect } from "react";
import { useSampleEdit } from "../../../api/posts";

export function Reachback({ sample }) {
  //state variables
  const [isReachback, setIsReachback] = useState(sample.reachback);
  const [isReachbackEmailSent, setIsReachbackEmailSent] = useState(
    sample.isReachbackEmailSent
  );

  const {
    mutateAsync,
    isSuccess: editSuccess,
    isError: editError,
  } = useSampleEdit(sample._id);

  //when the page first loads, check if reachback is true and email has not been sent
  useEffect(() => {
    if (isReachback && !isReachbackEmailSent) {
      handleReachback();
    }
  }, []);

  //function for sending reachback email and updating isReachbackEmailSent value in database
  const sendReachbackEmail = async (emailData) => {
    // sendReachbackEmail function
    try {
      console.log("Sending email...");
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/send-email`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: "reachback@spectraplasmonics.com",
            from: "Reachback Service Requested",
            subject: `Reachback Sample: ${emailData.sampleId}, Customer ID: ${emailData.customerId} `,
            html: `
                    <h1>Sample information:</h1>
                    <p>Customer ID: ${emailData.customerId}</p>
                    <p>Processed Date: ${emailData.processedDate}</p>
                    <p>Sample ID: ${emailData.sampleId}</p>
                    <p>Was there an error with the trace scan? ${emailData.isErrorT}</p>
                    <p>Was there an error with the bulk scan? ${emailData.isErrorB}</p>
                    <p>Notes: ${emailData.notes}</p>
                `,
          }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        console.log(data.messageId);
        console.log("Email sent successfully!");
        setIsReachbackEmailSent(true);
        await mutateAsync({
          id: sample._id,
          data: { isReachbackEmailSent: true },
        });
      } else {
        console.error("Error sending email:", data.error);
        console.error("Email sending failed!");
        setIsReachbackEmailSent(false);
      }
    } catch (error) {
      console.error("Error sending email:", error);
      console.error("Email sending failed!");
      setIsReachbackEmailSent(false);
    }
  };

  const handleReachback = async () => {
    const emailData = {
      customerId: sample.customerId,
      processedDate: sample.processedDate,
      sampleId: sample.sampleId,
      isErrorT: sample.isErrorT,
      isErrorB: sample.isErrorB,
      notes: sample.description,
    };

    await sendReachbackEmail(emailData);

    const editData = {
      id: sample._id,
      data: { reachback: true, reachbackComplete: "inProgress" },
    };
    await mutateAsync(editData);
  };

  const handleClick = () => {
    setIsReachback(true);
    handleReachback();
  };
  return null;
}
